// extracted by mini-css-extract-plugin
export default {"body":"LoginPage_body__SdicB"};